// Page-specific styles for the JurisdictionGatePage radio cards.
// Shared form atoms (label, button, message) live in
// ../../components/onboarding/onboarding-form.styles.ts.

import type { CSSProperties } from "react";

export const radioGroup: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-3)",
};

const baseRadioRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "var(--sz-space-3)",
  padding: "14px 18px",
  background: "var(--sz-bg-surface-2)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-md)",
  cursor: "pointer",
  transition: "border-color var(--sz-duration-fast), background var(--sz-duration-fast)",
};

export const radioRow: CSSProperties = baseRadioRow;

export const radioRowSelected: CSSProperties = {
  ...baseRadioRow,
  borderColor: "var(--sz-amber)",
  background: "var(--sz-amber-glow)",
};

export const radioInput: CSSProperties = {
  accentColor: "var(--sz-amber)",
  width: "16px",
  height: "16px",
};

export const radioLabel: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  flex: 1,
};

export const radioTitle: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-md)",
  color: "var(--sz-text-primary)",
  fontWeight: 500,
};

export const radioMeta: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "1.5px",
  color: "var(--sz-text-muted)",
};

export const otherInputBlock: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-2)",
  marginTop: "var(--sz-space-2)",
};
